document.addEventListener('DOMContentLoaded', () => {
  const setupCarousel = (root) => {
    if (root.dataset.aqCarouselReady === 'true') return;
    root.dataset.aqCarouselReady = 'true';
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const count = root.querySelector('[data-carousel-count]');
    if (!slides.length) return;
    let index = 0;
    let touchX = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
    };
    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
    root.addEventListener('touchstart', (event) => { touchX = event.changedTouches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  };

  document.querySelectorAll('[data-aq-product-carousel]').forEach(setupCarousel);

  const revealItems = [...document.querySelectorAll('[data-aq-reveal]')];
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-aq-product-carousel]').forEach(setupCarousel);
    event.target.querySelectorAll('[data-aq-reveal]').forEach((item) => item.classList.add('is-aq-visible'));
  });
  if (!revealItems.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-aq-visible'));
    return;
  }
  document.documentElement.classList.add('aq-motion-ready');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-aq-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  revealItems.forEach((item) => observer.observe(item));
});
